import { render } from "./FemaleUsersList.vue?vue&type=template&id=15af48a4&scoped=true"
import script from "./FemaleUsersList.vue?vue&type=script&lang=js"
export * from "./FemaleUsersList.vue?vue&type=script&lang=js"

import "./FemaleUsersList.vue?vue&type=style&index=0&id=15af48a4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-15af48a4"

export default script